// Utility to manage body scroll lock for embed environment
class ScrollLock {
  constructor() {
    this.locked = false;
    this.originalStyle = {};
    this.lockCount = 0; // Track multiple modals
  }

  lock() {
    this.lockCount++;

    if (this.locked) return;

    // Get the current scroll position
    const scrollY = window.scrollY;
    const scrollX = window.scrollX;

    // Store original styles
    this.originalStyle = {
      position: document.body.style.position || '',
      top: document.body.style.top || '',
      left: document.body.style.left || '',
      width: document.body.style.width || '',
      overflow: document.body.style.overflow || '',
      scrollY,
      scrollX,
    };

    // Apply scroll lock styles
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = `-${scrollX}px`;
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';

    // Add class for additional CSS targeting
    document.body.classList.add('modal-open');

    this.locked = true;
  }

  unlock() {
    this.lockCount = Math.max(0, this.lockCount - 1);

    // Only unlock if no other modals are open
    if (this.lockCount > 0 || !this.locked) return;

    // Remove class
    document.body.classList.remove('modal-open');

    // Restore original styles
    document.body.style.position = this.originalStyle.position;
    document.body.style.top = this.originalStyle.top;
    document.body.style.left = this.originalStyle.left;
    document.body.style.width = this.originalStyle.width;
    document.body.style.overflow = this.originalStyle.overflow;

    // Restore scroll position
    window.scrollTo(this.originalStyle.scrollX, this.originalStyle.scrollY);

    this.locked = false;
  }

  // Force unlock (for cleanup)
  forceUnlock() {
    this.lockCount = 0;
    this.unlock();
  }
}

// Create a singleton instance
const scrollLock = new ScrollLock();

export default scrollLock;
